<template>
  <div class="prop-table">
    <div class="opera">
      <el-button class="btn-create-line" icon="el-icon-plus" @click="createNewLine">添加行</el-button>
    </div>
    <el-table :data="rows">
      <el-table-column label="属性名称">
        <el-input slot-scope="{ row }" v-model="row.name" placeholder="请输入" @change="handleChange"/>
      </el-table-column>
      <el-table-column label="变量名称">
        <el-input slot-scope="{ row }" v-model="row.variableName" placeholder="请输入" @change="handleChange"/>
      </el-table-column>
      <el-table-column label="变量值">
        <el-input slot-scope="{ row }" v-model="row.value" placeholder="请输入" @change="handleChange"/>
      </el-table-column>
      <el-table-column label="描述">
        <el-input slot-scope="{ row }" v-model="row.description" placeholder="请输入" @change="handleChange"/>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="{ row }">
          <el-button>上移</el-button>
          <el-button>下移</el-button>
          <el-button @click="deleteLine(row.frontId)" @change="handleChange">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { buildNewProp } from '../utils'

export default {
  name: 'PropTable',
  props: {
    props: {
      default () {
        return []
      }
    }
  },
  computed: {
    rows () {
      return this.props.filter(p => p.id == null || p.id > 0)
    }
  },
  methods: {
    // 添加行
    createNewLine () {
      this.handleChange()
      this.props.push(buildNewProp())
    },
    // 删除行
    deleteLine (frontId) {
      this.handleChange()
      const index = this.__getLineIndexByFrontId(frontId)
      // 未保存过的属性，直接删除
      if (this.props[index].id == null) {
        this.props.splice(index, 1)
        return
      }
      // 已保存过的，将ID设置为负数，保存后再删除记录
      this.props[index].id *= -1
    },
    // 内容变更
    handleChange () {
      this.$emit('change')
    },
    // 查询行索引
    __getLineIndexByFrontId (frontId) {
      return this.props.findIndex(p => p.frontId === frontId)
    }
  }
}
</script>

<style scoped lang="scss">
@import "../variables";
.prop-table {
  width: 100%;
  height: 100%;
  /deep/ .el-table {
    background-color: $table-background;
    &::before {
      background-color: $color-gray-deep;
    }
    tr, th {
      background-color: $table-background;
    }
    th.is-leaf, td {
      border-bottom-color: $color-gray-deep;
    }
    // 行hover
    .el-table__body tr:hover td {
      background-color: $table-background;
    }
    // 输入框
    .el-input {
      .el-input__inner {
        background-color: $input-background;
        border: 0;
        color: $color-white;
      }
    }
    // 按钮
    .el-button {
      background-color: $color-gray-deep;
      color: $color-white;
      border: 0;
      padding: 5px 10px;
      &:hover {
        background-color: $color-gray;
      }
    }
  }
  .opera {
    padding: 5px 10px;
    display: flex;
    justify-content: flex-end;
    background-color: $menu-background;
    .btn-create-line {
      background-color: $table-background;
      color: $color-white;
      border: 0;
      &:hover {
        background-color: $table-background + 5;
      }
    }
  }
}
</style>
